import KTTooltip from 'general/components/eInvoiceComponents/KTTooltip'

/**
 * @template T
 * @param {Object} props
 * @param {import('react-data-table-component').TableColumn<T>} props.column
 * @param {string} props.columnId
 * @param {number} props.currentWidth
 * @param {number} props.minWidth
 * @param {(columnId: string, width: number) => void} props.onResize
 */
function ResizableHeader({
  column,
  columnId,
  currentWidth,
  minWidth,
  onResize,
}) {
  const handleMouseDown = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const startX = e.clientX
    const startWidth = currentWidth

    const handleMouseMove = (moveEvent) => {
      const diff = moveEvent.clientX - startX
      const newWidth = Math.max(minWidth, startWidth + diff)

      onResize(columnId, newWidth)
    }

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)

      document.body.style.cursor = ''
      document.body.style.userSelect = ''
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)

    document.body.style.cursor = 'col-resize'
    document.body.style.userSelect = 'none'
  }

  return (
    <KTTooltip text={column.headerTooltip}>
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          padding: '0 16px',
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            flex: 1,
            whiteSpace: 'normal',
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            lineHeight: '1.4',
          }}
        >
          {column.name}
        </div>

        <div
          onMouseDown={handleMouseDown}
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '8px',
            height: '100%',
            cursor: 'col-resize',
            zIndex: 9999,
          }}
        />
      </div>
    </KTTooltip>
  )
}

export default ResizableHeader
